import React from 'react'
import { useTranslation } from 'react-i18next'
import storyOptions from '../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/components/Story/storyFormOptions.js'
import { Button, Form, Icon, Input, Modal, Tooltip } from 'antd'
import { formatLabel } from '../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/utils/index.js'
import { CreatableSelect } from '../../../components/index.js'
const StoryModal = ({ form, setStoryMode, visible, onCancel }) => {
  const { t } = useTranslation()
  const {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    getFieldValue,
    setFieldsValue
  } = form
  const newStoryOptions = {
    genre: storyOptions.genre,
    tone: storyOptions.tone
  }
  const handleStoryMode = e => {
    e.preventDefault()

    form.validateFields(Object.keys(newStoryOptions), (err, values) => {
      if (!err) {
        setStoryMode(values)
      } else {
        console.log('❌ Validation errors:', err)
      }
    })
  }
  return (
    <Modal
      width={800}
      title={'Story Preferences'}
      centered
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className={'story-preferences'}
    >
      <Form className="story-course-form" onSubmit={handleStoryMode}>
        {Object.entries(newStoryOptions).map(([key, values]) => (
          <Form.Item
            labelAlign="top"
            label={
              <span className="story-course-form-label">
                <span>{formatLabel(key)} </span>
                <Tooltip title={t(values.description)}>
                  <Icon type="info-circle" />
                </Tooltip>
              </span>
            }
            key={key}
          >
            {getFieldDecorator(key, {
              rules: [
                {
                  required: true,
                  message: t('v4:please_input_your') + ' ' + formatLabel(key) + '!'
                }
              ]
            })(
              values.value && values.value.length > 0 ? (
                <CreatableSelect
                  options={values.value.map(v => ({
                    value: t(v),
                    label: t(v)
                  }))}
                  placeholder={
                    t('v4:select_or_type_your') + ' ' + formatLabel(key)
                  }
                />
              ) : (
                <Input.TextArea
                  placeholder={t('v4:enter_your') + ' ' + formatLabel(key)}
                />
              )
            )}
          </Form.Item>
        ))}
        <div className="form-button-center">
          <Form.Item>
            <Button
              className="shl-primary-btn"
              htmlType="submit"
              shape="round"
              size="large"
            >
              Confirm Mode
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}
export default Form.create()(StoryModal)
